import { useEffect, useRef, useState } from "react";

const Tooltip = ({ text }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  const tooltipRef = useRef(null);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 800);
    };

    handleResize();

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (!isMobile) return;

    const handleClickOutside = (event) => {
      if (
        tooltipRef.current &&
        !tooltipRef.current.contains(event.target)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener("click", handleClickOutside);

    return () =>
      document.removeEventListener("click", handleClickOutside);
  }, [isMobile]);

  const handleClick = (event) => {
    if (!isMobile) return;

    event.stopPropagation();
    setIsOpen((prev) => !prev);
  };

  return (
    <div
      ref={tooltipRef}
      onMouseEnter={() => !isMobile && setIsOpen(true)}
      onMouseLeave={() => !isMobile && setIsOpen(false)}
      style={{
        position: "relative",
        display: "inline-flex",
        marginRight: "7px"
      }}
    >
      <div
        onClick={handleClick}
        style={{
          cursor: "pointer",
          userSelect: "none",
          width: "14px",
          height:"14px",
          border: "1px solid #fff",
          borderRadius: "50%",
          textAlign: "center",
          fontSize: "10px",
          background: "#4d85df",
          color: "#fff",
          marginLeft: "10px"
        }}
      >
        ?
      </div>

      {isOpen && (
        <div
          style={{
            position: "absolute",
            top: "-16px",
            left: "35px",
            marginTop: "8px",
            padding: "8px 12px",
            background: "#333",
            color: "#fff",
            borderRadius: "6px",
            zIndex: 1000,
            width:"200px",
          }}
        >
          {text}
        </div>
      )}
    </div>
  );
};

export default Tooltip;
